import { Auth } from "aws-amplify";
import classNames from "classnames";
import { format } from "date-fns";
import React, { useEffect } from "react";
import { useState } from "react";
import ReactExport from "react-data-export";
import { useSelector } from "react-redux";

import { pad, getCurrentLocalDateTime } from "../../../utils/getLocalDateTime";
import { getLastItem, prePareQueryRequest } from "../utils/leasing.u";
import _ from "lodash";
import API from "../api/api.main";
import axios from "axios";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let source = null

function FootageExportRequest({
  selectedRows,
  searchBy,
  formQuery,
  setCountRecord,
  setLoadingCountRecord,
  isTransfer,
  isLoan = false,
  countRecord,
  currentCountRecord,
}) {
  const [typeExport, setTypeExport] = useState("");
  const [loadingExportAll, setLoadingExportAll] = useState(false);
  const [loadingCountAll, setLoadingCountAll] = useState(false);
  const [allRequests, setAllRequests] = useState([]);

  const { user } = useSelector((state) => state.initializeApp);
  const searchBar = useSelector((state) => state.searchBar);

  useEffect(() => {
    if (currentCountRecord) {
      fetchLeasingAll();
      if (source) {
        return () => {
          source?.cancel("Operation canceled by the user.");
        };
      }
    }
  }, [currentCountRecord]);

  const checkLessZero = (number) => {
    return number < 0 ? "00" : number;
  };

  const getCountDown = (value) => {
    // Get today's date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = value - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the element with id="demo"
    return (
      pad(checkLessZero(days)) +
      ":" +
      pad(checkLessZero(hours)) +
      ":" +
      pad(checkLessZero(minutes)) +
      ":" +
      pad(checkLessZero(seconds))
    );
  };

  const style = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    // border: borderColumn,
  };

  const sameColumn = [
    {
      title: "เบอร์โทร",
      width: { wch: 38 },
      style,
    }, //p
    {
      title: "Job no",
      width: { wch: 28 },
      style,
    }, //pixels width
    {
      title: "ชื่อ",
      width: { wch: 38 },
      style,
    }, //pixels width
    {
      title: "วงเงินที่ได้",
      width: { wch: 24 },
      style,
    }, //char width
    {
      title: "วงเงินที่ขอ",
      width: { wch: 24 },
      style,
    },
    {
      title: "ประเภทสินเชื่อ",
      width: { wch: 24 },
      style,
    },
    {
      title: "วันที่สร้าง",
      width: { wch: 24 },
      style,
    },
    {
      title: "วันที่แก้ไข",
      width: { wch: 24 },
      style,
    },
    {
      title: "สถานะ",
      width: { wch: 24 },
      style,
    },
    {
      title: "Time Remain",
      width: { wch: 36 },
      style,
    },
    {
      title: "จองโดย",
      width: { wch: 24 },
      style,
    },
    {
      title: "แก้ไขโดย",
      width: { wch: 24 },
      style,
    },
    {
      title: "Complete Date",
      width: { wch: 24 },
      style,
    },
    {
      title: "Complete By",
      width: { wch: 24 },
      style,
    },
    {
      title: "Approve Date",
      width: { wch: 24 },
      style,
    },
    {
      title: "Approved By",
      width: { wch: 24 },
      style,
    },
  ];

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      // border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      result.push([
        {
          value: data[i]?.phone_number || "",
          style,
        },
        {
          value: data[i]?.request_id || "",
          style,
        },
        {
          value: data[i]?.name || "",
          style,
        },
        {
          value: data[i]?.requestamount || "",
          style,
        },
        {
          value: data[i]?.amount || "",
          style,
        },
        {
          value: data[i]?.purpose || "",
          style,
        },
        {
          value: data[i]?.timestamp
            ? format(new Date(data[i]?.timestamp), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.executeTime
            ? format(new Date(data[i]?.executeTime), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i]?.loan_status || "",
          style,
        },
        {
          value: 0,
          style,
        },
        {
          value: data[i]?.reserveBy || "",
          style,
        },
        {
          value: data[i]?.adminName || "",
          style,
        },
        {
          value:
            data[i].completedAt !== "-" && data[i].completedBy !== "-"
              ? format(new Date(data[i].completedAt), "dd-MM-yyyy")
              : "-",
          style,
        },
        {
          value:
            data[i].completedAt !== "-" && data[i].completedBy !== "-"
              ? data[i].completedBy
              : "-",
          style,
        },
        {
          value:
            data[i].approvedAt !== "-" && data[i].approvedBy !== "-"
              ? format(new Date(data[i].approvedAt), "dd-MM-yyyy")
              : "-",
          style,
        },
        {
          value:
            data[i].approvedAt !== "-" && data[i].approvedBy !== "-"
              ? data[i].approvedBy
              : "-",
          style,
        },
      ]);
    }
    return result;
  };

  const multiDataSetAll = [
    {
      columns: sameColumn,
      data: createDataWithStyle(
        typeExport === "all"
          ? allRequests
          : selectedRows?.map((row) => {
              return {
                ...row?.original,
              };
            })
      ),
    },
  ];

  const fetchLeasingAll = async () => {
    try {
      setLoadingExportAll(true);
      setLoadingCountRecord(true);
      let count = 0;
      let lastItem = null;
      let leasings = [];
      const convertPath = isLoan ? "loan" : "request";

      // console.log("checkListSubmitId()", checkListSubmitId());

      // setup AbortController
      // const controller = new AbortController();
      // // signal to pass to fetch
      // const signal = controller.signal;

      // if (checkListSubmitId()) {
      //   if (API.isCancel()) {
      //     console.log("Hello"); // "my message for cancellation"
      //     // handle user cancellation logic
      //   }
      // }

      do {
        source = axios.CancelToken.source();
        const data = await API.get("MoneyHubAdmin", `/leasing/${convertPath}`, {
          queryStringParameters: {
            ...prePareQueryRequest(
              _.cloneDeep(formQuery),
              searchBy,
              searchBar,
              isTransfer
            ),
            reserveByAdminName: user.username,
            ExclusiveStartKey: getLastItem(lastItem),
            Limit: 50,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
          cancelToken: source?.token,
        });

        if (isLoan) {
          leasings = [...leasings, ...data?.leasing_loans];
        } else {
          leasings = [...leasings, ...data?.leasing_requests];
        }
        lastItem = data?.lastItem;
        count = leasings.length;
      } while (lastItem !== null);

      setCountRecord((prev) => {
        return {
          ...prev,
          [currentCountRecord]: count,
        };
      });
      setAllRequests(leasings);
    } catch (error) {
      console.log("fetch leasing request error", error);
    } finally {
      setLoadingExportAll(false);
      setLoadingCountRecord(false);
    }
  };

  const onClickExport = () => {
    setTypeExport("single");
    const exportClick = document.getElementById("leasingRequestExport");
    exportClick.click();
  };

  const onClickExportAll = async () => {
    try {
      setTypeExport("all");
      const exportClick = document.getElementById("leasingRequestExportAll");
      exportClick.click();
    } catch (error) {
      console.log("export all", error);
    } finally {
      setLoadingExportAll(false);
    }
  };

  return (
    <div className="mr-2 flex items-center">
      <button
        disabled={!selectedRows}
        className={classNames(
          "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white",
          {
            "bg-gray-300 cursor-not-allowed text-white": !selectedRows.length,
            "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
              selectedRows.length,
          }
        )}
        onClick={onClickExport}
      >
        Export Excel
      </button>
      <ExcelFile
        filename={`LEASING_REQUEST_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="leasingRequestExport" hidden></button>}
      >
        <ExcelSheet
          dataSet={multiDataSetAll}
          name="LEASING REQUEST"
        ></ExcelSheet>
      </ExcelFile>
      <ExcelFile
        filename={`LEASING_REQUEST_ALL_${format(new Date(), "yyyy-MM-dd")}`}
        element={<button id="leasingRequestExportAll" hidden></button>}
      >
        <ExcelSheet
          dataSet={multiDataSetAll}
          name="LEASING REQUEST"
        ></ExcelSheet>
      </ExcelFile>
      {!isTransfer && (
        <button
          disabled={
            loadingExportAll ||
            loadingCountAll ||
            countRecord[currentCountRecord] === 0
          }
          className={classNames(
            "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white flex items-center space-x-1",
            {
              "bg-gray-300 cursor-not-allowed text-white":
                loadingExportAll ||
                loadingCountAll ||
                countRecord[currentCountRecord] === 0,
              "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
                (!loadingExportAll || loadingCountAll) &&
                countRecord[currentCountRecord] > 0,
            }
          )}
          onClick={onClickExportAll}
        >
          {(loadingExportAll || loadingCountAll) && (
            <svg
              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white ml-1"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx={12}
                cy={12}
                r={10}
                stroke="currentColor"
                strokeWidth={4}
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          )}
          Export Excel All ({countRecord[currentCountRecord]})
        </button>
      )}
    </div>
  );
}

export default FootageExportRequest;
